import mock from '../mock'
import { paginateArray } from '../utils'

const data = {
  users: []
  // users: [
  //   {
  //     id: 1,
  //     fullName: 'Galen Slixby',
  //     company: 'Yotz PVT LTD',
  //     role: 'editor',
  //     username: 'gslixby0',
  //     country: 'El Salvador',
  //     contact: '(479) 232-9151',
  //     email: 'gslixby0@abc.net.au',
  //     currentPlan: 'enterprise',
  //     status: 'pasif',
  //     lastActive: '13.04.2020',
  //     avatar: ''
  //   },
  //   {
  //     id: 2,
  //     fullName: 'Halsey Redmore',
  //     company: 'Skinder PVT LTD',
  //     role: 'author',
  //     username: 'hredmore1',
  //     country: 'Albania',
  //     contact: '(472) 607-9137',
  //     email: 'hredmore1@imgur.com',
  //     currentPlan: 'team',
  //     status: 'aktif',
  //     lastActive: '13.04.2020',
  //     avatar: ''
  //   },
  //   {
  //     id: 3,
  //     fullName: 'Marjory Sicely',
  //     company: 'Oozz PVT LTD',
  //     role: 'maintainer',
  //     username: 'msicely2',
  //     country: 'Russia',
  //     contact: '(321) 264-4599',
  //     email: 'msicely2@who.int',
  //     currentPlan: 'enterprise',
  //     status: 'aktif',
  //     lastActive: '13.04.2020',
  //     avatar: ''
  //   },
  //   {
  //     id: 4,
  //     fullName: 'Cyrill Risby',
  //     company: 'Oozz PVT LTD',
  //     role: 'maintainer',
  //     username: 'crisby3',
  //     country: 'China',
  //     contact: '(923) 690-6806',
  //     email: 'crisby3@wordpress.com',
  //     currentPlan: 'team',
  //     status: 'pasif',
  //     lastActive: '13.04.2020',
  //     avatar: ''
  //   },
  //   {
  //     id: 5,
  //     fullName: 'Maggy Hurran',
  //     company: 'Aimbo PVT LTD',
  //     role: 'subscriber',
  //     username: 'mhurran4',
  //     country: 'Pakistan',
  //     contact: '(669) 914-1078',
  //     email: 'mhurran4@yahoo.co.jp',
  //     currentPlan: 'enterprise',
  //     status: 'aktif',
  //     lastActive: '13.04.2020',
  //     avatar: ''
  //   },
  //   {
  //     id: 6,
  //     fullName: 'Silvain Halstead',
  //     company: 'Jaxbean PVT LTD',
  //     role: 'author',
  //     username: 'shalstead5',
  //     country: 'China',
  //     contact: '(958) 973-3093',
  //     email: 'shalstead5@shinystat.com',
  //     currentPlan: 'company',
  //     status: 'pasif',
  //     lastActive: '13.04.2020',
  //     avatar: ''
  //   }
  // ]
}

// GET ALL DATA
mock.onGet('/api/users/list/all-data').reply(200, data.users)

// POST: Add new user
mock.onPost('/apps/users/add-user').reply(config => {
  // Get event from post data
  const user = JSON.parse(config.data)

  const { length } = data.users
  let lastIndex = 0
  if (length) {
    lastIndex = data.users[length - 1].id
  }
  user.id = lastIndex + 1

  data.users.unshift(user)

  return [201, { user }]
})

// GET Updated DATA
mock.onGet('/api/users/list/data').reply(config => {
  const { q = '', perPage = 10, page = 1, role = null, currentPlan = null, status = null } = config

  /* eslint-disable  */
  const queryLowered = q.toLowerCase()
  const filteredData = data.users.filter(
    user =>
      (user.username.toLowerCase().includes(queryLowered) || user.fullName.toLowerCase().includes(queryLowered)) &&
      user.role === (role || user.role) &&
      user.currentPlan === (currentPlan || user.currentPlan) &&
      user.status === (status || user.status)
  )
  /* eslint-enable  */

  return [
    200,
    {
      users: paginateArray(filteredData, perPage, page),
      total: filteredData.length
    }
  ]
})

// GET USER
mock.onGet('/api/users/user').reply(config => {
  const { id } = config
  const user = data.users.find(i => i.id === id)
  return [200, { user }]
})

// DELETE: Deletes User
mock.onDelete('/apps/users/delete').reply(config => {
  // Get user id from URL
  let userId = config.id

  // Convert Id to number
  userId = Number(userId)

  const userIndex = data.users.findIndex(t => t.id === userId)
  data.users.splice(userIndex, 1)

  return [200]
})
